import { render, staticRenderFns } from "./SmallBlogPostCard.vue?vue&type=template&id=b7ca089a"
import script from "./SmallBlogPostCard.vue?vue&type=script&lang=ts"
export * from "./SmallBlogPostCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports